import { AuthProvider } from './context/AuthContext';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import ProtectedRoute from './components/ProtectedRoute';
import './App.css';
import CustomerDetailsForm from './CustomerDetails';
import ItemSelector from './ItemSelector';
import Login from './Login';
import Navbar from './Navbar';
import QuotationList from './QuotationList';
import TestApi from './TestApi';
import JobCardForm from './JobCardForm';
import PriceChecker from './PriceChecker';
import EditQuotation from "./EditQuotation";
import PriceChange from './PriceChange';
import RepairEstimate from './RepairEstimate';
import EstimateList from "./EstimateList";
import EditEstimate from "./EditEstimate";
import Dashboard from "./Dashboard";
import WhatsAppManager from "./WhatsAppManager";
import FollowUpPage from "./FollowUpPage";
import HsnManager from "./HsnManager";
import AttendanceManager from "./AttendanceManager";
import LiveAttendance from "./LiveAttendance";
import { useAuth } from './context/AuthContext';

// Inner component to handle Navbar visibility which needs auth context
const AppContent = () => {
    const { isAuthenticated, logout, user } = useAuth();
    
    return (
        <Router>
            {isAuthenticated && <Navbar onLogout={logout} user={user} />} 
        
            <Routes>
              <Route path="/login" element={<Login />} />
              
              <Route
                path="/quotations"
                element={
                  <ProtectedRoute>
                    <QuotationList />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/maker"
                element={
                  <ProtectedRoute>
                    <ItemSelector />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/add-jobcard"
                element={
                  <ProtectedRoute>
                    <JobCardForm />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/price-check"
                element={
                  <ProtectedRoute>
                    <PriceChecker/>
                  </ProtectedRoute>
                }
              />

              <Route
                path="/estimate"
                element={
                  <ProtectedRoute>
                    <RepairEstimate />
                  </ProtectedRoute>
                }
              />

              <Route
                path="/estimates"
                element={
                  <ProtectedRoute>
                    <EstimateList />
                  </ProtectedRoute>
                }
              />

              <Route
                path="/edit-estimate/:id"
                element={
                  <ProtectedRoute>
                    <EditEstimate />
                  </ProtectedRoute>
                }
              />
        
              <Route path="/edit-quotation/:id" 
                element={
                  <ProtectedRoute>
                    <EditQuotation/> 
                  </ProtectedRoute>
                } 
              />
           <Route
            path="/price-change"
            element={
              <ProtectedRoute>
                <PriceChange />
              </ProtectedRoute>
            }
          />
          <Route
            path="/whatsapp"
            element={
              <ProtectedRoute>
                <WhatsAppManager />
              </ProtectedRoute>
            }
          />
          <Route
            path="/followups"
            element={
              <ProtectedRoute>
                <FollowUpPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/hsn-manager"
            element={
              <ProtectedRoute>
                <HsnManager />
              </ProtectedRoute>
            }
          />
          <Route
            path="/attendance"
            element={
              <ProtectedRoute>
                <AttendanceManager />
              </ProtectedRoute>
            }
          />
          <Route
            path="/live-attendance"
            element={
              <ProtectedRoute>
                <LiveAttendance />
              </ProtectedRoute>
            }
          />
        
              <Route path="/" element={
                 <ProtectedRoute>
                    <Dashboard />
                 </ProtectedRoute>
              } />
            </Routes>
          </Router>
    );
};

function App() {
  return (
    <AuthProvider>
      <AppContent />
    </AuthProvider>
  );
}

export default App;
